import { AppstoreOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const MyDecksPage = lazyRouteComponent(() => import('./pages/list'));
const DeckDetailsPage = lazyRouteComponent(() => import('./pages/details'));
const DeckImportPage = lazyRouteComponent(() => import('./pages/import'));
const PublicDeckPage = lazyRouteComponent(() => import('./pages/public'));
const OptimizedPurchasePage = lazyRouteComponent(
  () => import('./pages/optimized-purchase'),
);

const SellDeckPage = lazyRouteComponent(() => import('./pages/sell'));
const DeckSalesPage = lazyRouteComponent(() => import('./pages/marketplace'));
const DeckSaleDetailsPage = lazyRouteComponent(
  () => import('./pages/sale-details'),
);

const DeckSaleManagementPage = lazyRouteComponent(
  () => import('./pages/sale-management'),
);

export const getRoutes = (): Route[] => [
  {
    page: SellDeckPage,
    path: ROUTE_PATHS.DECK_SELL,
    title: 'Vender conjunto',
    hidden: true,
  },
  {
    page: DeckSaleManagementPage,
    path: ROUTE_PATHS.DECK_SALE_MANAGE,
    title: 'Gerenciar anúncio',
    hidden: true,
  },
  {
    page: OptimizedPurchasePage,
    path: ROUTE_PATHS.OPTIMIZED_PURCHASE,
    title: 'Compra otimizada',
    hidden: true,
  },
  {
    page: MyDecksPage,
    path: ROUTE_PATHS.MY_DECKS,
    title: 'Meus decks',
    icon: AppstoreOutlined,
  },
  {
    page: DeckDetailsPage,
    path: ROUTE_PATHS.DECK_DETAILS,
    title: 'Detalhes do deck',
    hidden: true,
  },
  {
    page: DeckImportPage,
    path: ROUTE_PATHS.DECK_IMPORT,
    title: 'Importar deck',
    hidden: true,
  },
];

export const getPublicRoutes = (): Route[] => [
  {
    page: DeckSalesPage,
    path: ROUTE_PATHS.DECK_MARKETPLACE,
    title: 'Decks',
    hidden: true,
    public: true,
  },
  {
    page: DeckSaleDetailsPage,
    path: ROUTE_PATHS.DECK_SALE_DETAILS,
    title: 'Oferta de deck ou set',
    hidden: true,
    public: true,
  },
  {
    page: PublicDeckPage,
    path: ROUTE_PATHS.PUBLIC_DECK,
    title: 'Deck compartilhado',
    hidden: true,
    public: true,
  },
];
